import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'tumblr-third-party-glyph-icon'

export function TumblrSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <path d="M24.248 25.528c-.609.283-1.774.53-2.643.552-2.621.07-3.13-1.796-3.153-3.15v-9.95h6.577V8.144h-6.552V.003h-4.798a.254.254 0 0 0-.235.238C13.164 2.733 11.967 7.106 7 8.853v4.128h3.315v10.443c0 3.574 2.702 8.653 9.837 8.535 2.406-.04 5.08-1.025 5.671-1.872l-1.575-4.559Z" />
    </symbol>
  )
}

const TumblrStandaloneContent = standalone(TumblrSymbol, ID)

export const Tumblr = styled(function TumblrStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tumblr">
      <TumblrStandaloneContent />
    </Icon>
  )
})``

export const TumblrLightweight = styled(function TumblrComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-tumblr">
      {lightweight(ID)}
    </Icon>
  )
})``
